var initialState = {
	isLoaded: false,
	dudReasons: []
}

export default function activeClient(state = initialState, action = {}) {
    switch (action.type) {
        case 'LOAD_DUD_REASON_SUCCESS':
        	var dudReasons = action.result;
            return {
                ...state,
                isLoaded: true,
                dudReasons
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/reducers/dudReasons.js